// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".MatchResult a{color:inherit;-webkit-text-decoration:none;text-decoration:none}.MatchResult img{height:100%;-o-object-fit:contain;object-fit:contain;width:100%}.MatchResult .Abstract{border:1px solid #ececec}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
